import { BookingStatus } from './entities/type';

export const INVOICE_MANAGE_STATUSES: BookingStatus[] = [
  'COMPLETE',
  'PAYMENT_PENDING',
  'PAID',
  'DONE',
];

export function canManageBookingInvoice(
  status: BookingStatus | string | undefined | null,
  _hasInvoice = false,
): boolean {
  if (!status || status === 'CANCELLED') {
    return false;
  }

  return INVOICE_MANAGE_STATUSES.includes(status as BookingStatus);
}

export function getInvoiceActionLabel(hasInvoice: boolean): string {
  return hasInvoice ? 'Edit Invoice' : 'Create Invoice';
}

export function hasBookingInvoice(booking?: {
  invoiceCreated?: boolean;
  invoiceUrl?: string | null;
} | null): boolean {
  return Boolean(booking?.invoiceCreated || booking?.invoiceUrl);
}
